export default {
	'invoice-type': 'Invoice type'
}